import { Switch } from '@headlessui/react'
import ctl from '@netlify/classnames-template-literals'

export interface WidgetInputToggleFieldProps {
	value: boolean
	onChange: (value: boolean) => void
	disabled?: boolean
	ariaLabel?: string
}

export function WidgetInputToggleField(
	{ value, onChange, disabled = false, ariaLabel = 'Toggle' }: WidgetInputToggleFieldProps,
) {
	return (
		<Switch
			checked={value}
			onChange={onChange}
			disabled={disabled}
			aria-label={ariaLabel}
			className={ctl(`
				relative inline-flex items-center
				h-5 w-10
				my-1
				rounded-full transition-colors duration-200
				${value ? 'bg-purple-400' : 'bg-grey-200'}
				${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
			 inset-shadow-sm
			`)}
		>
			<span
				aria-hidden="true"
				className={ctl(`
					inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200
					${value ? 'translate-x-5' : 'translate-x-1'}
				`)}
			/>
			<span
				aria-hidden="true"
				className={ctl(`
					absolute left-1 top-1/2 -translate-y-1/2 transition-opacity duration-200
					text-grey-600 ${value ? 'opacity-0' : 'opacity-100'}
				`)}
			>
				<CrossIcon />
			</span>

			<span
				aria-hidden="true"
				className={ctl(`
					absolute right-1 top-1/2 -translate-y-1/2 transition-opacity duration-200
					text-purple-600 ${value ? 'opacity-100' : 'opacity-0'}
				`)}
			>
				<CheckIcon />
			</span>
		</Switch>
	)
}

function CheckIcon() {
	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="size-4">
				<path
					fillRule="evenodd"
					d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z"
					clipRule="evenodd"
				/>
			</svg>
		</>
	)
}

function CrossIcon() {
	return (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="size-4">
				<path d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
			</svg>
		</>
	)
}
